import axios from "axios";
var url = '';
if(window.location.origin == 'https://web.yuwenjl.com'){
  url = 'https://app.yuwenjl.com/'
} else {
  url = 'https://lite.yuwenjl.com/'
  // url = 'https://aimemorys.zens10.com/'
};
const service  = axios.create({
  baseURL:url,
  timeout:60000
});
// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    // 根据接口文档，处理响应数据
    if(res.code == 403){
      // window.location.href = '/';
      return false;
    }
    if (res.code !== 200) {
      console.log('请求失败：', res.msg);
      return Promise.reject(res.msg);
    } else {
      return res;
    }
  },
  error => {
    // 处理响应错误
    console.error('响应错误：', error);
    return Promise.reject(error);
  }
);
export default service 


// WEBPACK FOOTER //
// ./src/assets/js/request.js